import {
    NONUSER_CHARGE_STATUS_UNPAID,
    NONUSER_CHARGE_STATUS_FAILED,
    NONUSER_CHARGE_STATUS_REVOKED,
    NONUSER_CHARGE_STATUS_SUCCESS,

    NONUSER_CHARGE_EXPENSE_TYPE_LOSS,
    NONUSER_CHARGE_EXPENSE_TYPE_REPAIR,

    NONUSER_ERROR_TITLE_OUT_OF_RANGE,
    NONUSER_ERROR_AMOUNT_OUT_OF_RANGE
} from 'constants/nonuser-charge';

const nonuserChargeStatus = {
    [NONUSER_CHARGE_STATUS_UNPAID]: '尚未付款',
    [NONUSER_CHARGE_STATUS_SUCCESS]: '付款成功',
    [NONUSER_CHARGE_STATUS_FAILED]: '付款失敗',
    [NONUSER_CHARGE_STATUS_REVOKED]: '案件已刪除',
};

const nonuserExpenseType = {
    [NONUSER_CHARGE_EXPENSE_TYPE_LOSS]: '營業損失',
    [NONUSER_CHARGE_EXPENSE_TYPE_REPAIR]: '維修',
}

const nonuser_charge = {
    'new': '新增索費項目',
    'details': '詳細資料',
    'status': '狀態',
    'case_name': '案件名稱',
    'nonuser_charge_status_map': nonuserChargeStatus,
    'nonuser_expense_type_map': nonuserExpenseType,
    'expense_type': '費用項目',
    'payment_link': '付款連結',
    'create_time': '建立時間',
    'invalid_link': '超過付款期限',
    'revoke_fee': '刪除',
    'revoke_warning': '確認刪除此筆費用嗎？',
    [`create_error_message_${ NONUSER_ERROR_TITLE_OUT_OF_RANGE }`]: '案件名稱過長',
    [`create_error_message_${ NONUSER_ERROR_AMOUNT_OUT_OF_RANGE }`]: '金額超出範圍',
};

export default nonuser_charge;
